import { FC } from 'react'
import { NxCentralizedLoading } from '../../../components/loading'

const LoadingMfe: FC = (): React.ReactElement => {
  return (
    <div style={{ height: 'calc(100dvh - 88px)' }}>
      <NxCentralizedLoading ariaLabel='Carregando...' />
    </div>
  )
}

export default LoadingMfe
